// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__1ZmKw","hideOnTablet":"styles_hideOnTablet__3z7QB","hideOnMobile":"styles_hideOnMobile__203HP","cards":"styles_cards__ypgRc"};